export enum InsuranceTypeOption {
	Term = 'Term',
	LifeInsurance = 'Life Insurance',
	Other = 'Other',
}